import OrderInfo from "./OrderInfo";

export default function InfoPanel(props) {
  return <OrderInfo />;
}
